export const migrations =  {
  0: (state) => {
      return {

      }
  }
};


// WEBPACK FOOTER //
// ./src/store/migrations.js